import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getFirstAvailableImageForSize',
})
export class GetFirstAvailableImageForSizePipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    if (!value || !(value as any).length) {
      return 'assets/layout/images/no-image.png';
    }
    const preferredSize = args.length ? args[0] : 200;
    const images = value as any;
    for (let i = 0; i < images.length; i++) {
      const sizes = images[i].sizes;
      if (sizes.length) {
        const availableAtPreferred = sizes.filter(
          (s) => s.height <= preferredSize
        );
        if (availableAtPreferred.length) {
          //Sorts the filtered values from high to low to give the closest image
          availableAtPreferred.sort((a, b) => b.height - a.height);
          return availableAtPreferred[0].url;
        }
      }
    }
    // Just return the URL if nothing is found in sizes. Also move this up so we can save some mental logistics
    if (images[0] && !images[0].sizes.length) {
      return images[0].url;
    }
    return 'assets/layout/images/no-image.png';
  }
}
